import { render, staticRenderFns } from "./MypageReferralCodePage.vue?vue&type=template&id=b21500ec"
import script from "./MypageReferralCodePage.vue?vue&type=script&lang=ts"
export * from "./MypageReferralCodePage.vue?vue&type=script&lang=ts"
import style0 from "./MypageReferralCodePage.vue?vue&type=style&index=0&id=b21500ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports